module.exports = __webpack_public_path__ + "img/pr-6.17f01237.png";